var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowThinDownLegacy = function SvgArrowThinDownLegacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M5.646 9.896 10 14.249l4.354-4.353-.707-.708L10 12.835 6.354 9.188z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowThinDownLegacy;